const clamp=(v,lo,hi)=>Math.max(lo,Math.min(hi,v));
const noise=n=>{let x=(n|0)^0x9e3779b9;x=Math.imul(x^(x>>>16),0x21f0aaad);x=Math.imul(x^(x>>>15),0x735a2d97);return ((x^(x>>>15))>>>0)/4294967296;};
export function createEncounter(mode='responsive'){
 return {tick:0,mode,phase:mode==='fixed'?'fixed':'build',phaseTime:0,budget:6,regenerated:0,spent:0,enemies:[],spawned:0,defeated:0,lastSpawn:-99,reserve:100,intensity:0,restBeats:0,spawnEvent:false,dashEvent:false,attack:null,upgradeActive:false,player:{x:.5,y:.5}};
}
export function stepEncounter(state,options={}){
 const {seed=17,cadence=2,enemyHealth=2,policy='aggressive',rest=10,upgrade='none'}=options;
 const s={...state,tick:state.tick+1,phaseTime:state.phaseTime+1,enemies:state.enemies.map(e=>({...e})),spawnEvent:false,dashEvent:false,attack:null};
 const refill=Math.min(1,6-s.budget);s.budget+=refill;s.regenerated+=refill;
 const allowSpawn=s.mode==='fixed'||s.phase==='build'||s.phase==='sustain';
 if(allowSpawn&&s.tick-s.lastSpawn>=cadence&&s.budget>=2&&s.enemies.length<10){
  const side=noise(seed+s.spawned*31),y=.16+noise(seed+s.spawned*31+1)*.68,x=side<.5?.08:.92;
  s.enemies.push({id:s.spawned,x,y,spawnX:x,spawnY:y,hp:enemyHealth,maxHp:enemyHealth});
  s.spawned++;s.lastSpawn=s.tick;s.budget-=2;s.spent+=2;s.spawnEvent=true;
 }
 const angle=s.tick*(policy==='aggressive'?.31:.18),radius=policy==='aggressive'?.16:.08;
 s.player={x:.5+Math.cos(angle)*radius,y:.5+Math.sin(angle)*radius};
 const activeUpgrade=state.defeated>=3&&upgrade!=='none';
 s.dashEvent=activeUpgrade&&upgrade==='dash'&&s.enemies.length>0&&s.tick%4===0;
 if(s.dashEvent){s.player.x=clamp(s.player.x+.22*Math.sign(Math.cos(angle)),.15,.85);}
 s.enemies.forEach(e=>{const dx=s.player.x-e.x,dy=s.player.y-e.y,d=Math.hypot(dx,dy);if(d>.04){e.x+=dx/d*Math.min(.034,d);e.y+=dy/d*Math.min(.034,d);}});
 if(s.enemies.length){
  const target=s.enemies.reduce((best,e)=>Math.hypot(e.x-s.player.x,e.y-s.player.y)<Math.hypot(best.x-s.player.x,best.y-s.player.y)?e:best);
  const damage=(policy==='aggressive'?.65:.34)*(activeUpgrade&&upgrade==='power'?1.5:1);
  target.hp-=damage;s.attack={x:target.x,y:target.y};
  if(target.hp<=0){s.enemies=s.enemies.filter(e=>e.id!==target.id);s.defeated++;}
 }
 s.upgradeActive=s.defeated>=3&&upgrade!=='none';
 const exposure=s.dashEvent?.2:policy==='aggressive'?.95:.5;
 s.reserve=clamp(s.reserve-(s.enemies.length*exposure)+(s.enemies.length===0?5:0),0,100);
 s.intensity=clamp(state.intensity*.75+clamp(s.enemies.length/4+(100-s.reserve)/180,0,1)*.25,0,1);
 if(s.enemies.length===0)s.restBeats++;
 if(s.mode==='responsive'){
  let next=s.phase;
  if(s.phase==='build'&&(s.intensity>=.55||s.phaseTime>=18))next='sustain';
  else if(s.phase==='sustain'&&s.phaseTime>=6)next='fade';
  else if(s.phase==='fade'&&s.enemies.length===0)next='relax';
  else if(s.phase==='relax'&&s.phaseTime>=rest)next='build';
  if(next!==s.phase){s.phase=next;s.phaseTime=0;}
 }
 return s;
}
export function simulateEncounter(config={},mode='responsive',beats=100){const run=[createEncounter(mode)];for(let i=0;i<beats;i++)run.push(stepEncounter(run.at(-1),config));return run;}
